import React, {useState, useEffect} from "react";

export default function PolarFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M464.2447,458.6097c-0.2194-3.3517-3.5398-53.4664-6.5594-65.5313
		c-3.1533-12.6174-7.301-42.7405-8.3455-54.2602c-1.0654-11.6565-14.6333-88.8548-17.7866-96.1985
		c-1.2858-3.0071-5.8387-19.5738-11.1029-38.7496c-7.3751-26.8434-16.5458-60.2472-20.2318-68.8329
		c-4.272-9.9948-10.1002-19.1456-13.2336-24.0651c-1.2639-1.9846-2.3501-3.6975-2.4034-4.0098
		c0-1.41-12.419-11.7192-24.4191-17.7145c-11.838-5.919-48.9236-15.9542-52.7672-16.9861l0.0405-0.3188
		c0.541-2.1454,1.0026-4.3244,1.4412-6.4363c0.2298-1.0977,0.4606-2.1934,0.6998-3.2901c0.1995-0.9087,0.4711-1.8498,0.7217-2.747
		c0.6779-2.3721,1.3787-4.8256,1.0549-7.3752c-1.1709-9.087-11.7829-10.3812-19.533-11.3223
		c-1.1061-0.1347-2.1725-0.2705-3.1429-0.4063c-2.4963-0.3771-5.0355-0.8053-7.489-1.2325
		c-4.858-0.8262-9.8715-1.6816-14.8641-2.1005c-6.9041-0.564-14.5069-0.5223-22.6226,0.1254
		c-6.7787,0.5431-13.6932,1.4738-21.1624,2.841c-1.3892,0.2507-2.7773,0.5222-4.1664,0.8053
		c-0.7729,0.1451-1.5668,0.3029-2.3616,0.4481c-3.3528,0.6486-6.8309,1.316-10.048,2.4441
		c-3.7393,1.3056-6.0058,3.803-6.5479,7.2175c-0.6382,4.0526,0.3123,8.1052,1.2314,12.022l0.282,1.1699
		c0.6486,2.8003,1.338,5.5358,2.0587,8.147c-3.7403,1.0142-40.9336,11.0622-52.7896,16.9949
		c-12.0012,5.9954-24.4191,16.3045-24.4191,17.7041c-0.0533,0.3228-1.1489,2.0357-2.4138,4.0203
		c-3.123,4.9195-8.9503,14.0703-13.2337,24.0651c-3.6755,8.5857-12.8566,41.9895-20.2307,68.8329
		c-5.2653,19.1758-9.8088,35.7425-11.104,38.7496c-3.1439,7.3438-16.7222,84.542-17.7761,96.1985
		c-1.055,11.5197-5.2026,41.6428-8.3466,54.2602c-3.0175,12.0649-6.34,62.1796-6.5583,65.5313
		c-0.1368,0.116-0.2308,0.282-0.2402,0.4805c-0.0209,0.3238,0.1567,0.6069,0.4387,0.6998
		c19.4798,6.7275,32.7657,8.5334,41.4245,8.5334c4.4286,0,7.6342-0.47,9.8391-1.0027c0.6257-0.1452,1.0643-0.6894,1.1583-1.3997
		l0.0314,0.0105c0.0323-0.187,0.9087-4.8778,2.2247-11.8748l0.0533-0.0836c-0.0115,0-0.022-0.0115-0.0313-0.0115
		c3.8333-20.2725,11.4152-59.7135,13.4833-65.5094c2.3616-6.5918,18.1741-64.9683,20.2109-76.1851
		c1.4738-8.0844,11.0089-36.8297,16.9521-52.8417c-0.1044,13.9032-1.0549,77.2504-1.0654,77.92l-2.0054,77.8761
		c-0.0094,0.1462-1.7234,14.1006-1.5563,21.4026c0.1044,4.6062,6.4445,8.3559,11.7505,10.6841
		c3.6557,1.6085,7.5726,2.653,11.6367,3.1032l66.8578,7.3532c0.6058,0.0616,1.222,0.1357,1.8278,0.2089
		c1.4727,0.1776,2.9977,0.3552,4.5122,0.469h0.094c0.9808,0.0742,2.0357,0.1473,3.0802,0.1473c0.9922,0,1.995-0.0637,2.9361-0.2726
		c0.3958-0.0825,0.9808-0.2392,1.4403-0.6256c0.6487-0.5327,0.8993-1.3474,0.9829-1.9438c0.0104-0.0303,0.0104-0.0721,0.0104-0.1139
		c0.2596-0.0433,0.7539-0.1161,1.4243-0.1776c0.1282,0.8574,0.8611,1.5178,1.7533,1.5178h0.9254
		c0.9054,0,1.6452-0.6791,1.7589-1.5538c0.3805,0.0255,0.7698,0.0558,1.178,0.0987c0.1462,0.564,0.6685,1.8488,2.4441,2.5068
		c0.6465,0.2392,1.3892,0.2392,2.0472,0.2392h0.4387c1.1061,0,2.2039-0.0616,3.217-0.1254
		c2.4117-0.1661,4.8453-0.4272,7.1954-0.6883l0.7635-0.0836c5.2329-0.586,10.4647-1.1395,15.6976-1.7036l18.7068-2.0159
		c3.0196-0.3228,6.1102-0.5954,9.0975-0.8669c7.8755-0.6894,16.0236-1.4195,23.8676-3.1429l0.8565-0.188
		c6.8519-1.4947,19.605-4.272,19.7921-12.8264c0.0354-1.6013-0.0186-3.5126-0.124-5.5253c0.1278-0.2354,0.2425-0.4731,0.3378-0.7141
		l-0.3737,0.0732c-0.0767-1.3423-0.1737-2.7162-0.282-4.0701c0.1946-0.5347,0.3067-1.0826,0.3191-1.6431l-0.4474,0.0959
		c-0.2181-2.5211-0.4594-4.8751-0.6519-6.6528c-0.2288-2.0775-0.375-4.2197-0.4283-6.3808l-1.9114-74.4617
		c-0.0104-0.6696-0.9714-64.0168-1.0748-77.92c5.9421,16.012,15.4897,44.7574,16.9625,52.8417
		c2.0358,11.2168,17.8389,69.5933,20.2004,76.1851c2.0775,5.7959,9.6616,45.2369,13.4949,65.5094
		c-0.0105,0-0.022,0.0115-0.0314,0.0115l0.0417,0.0836c1.3255,6.997,2.1924,11.6878,2.2342,11.8748l0.0219-0.0105
		c0.1035,0.7103,0.5421,1.2545,1.1688,1.3997c2.1934,0.5327,5.4115,1.0027,9.8391,1.0027c8.6495,0,21.9458-1.8059,41.4245-8.5334
		c0.282-0.093,0.4596-0.376,0.4387-0.6998C464.4745,458.8917,464.3805,458.7257,464.2447,458.6097z"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M344.7247,406.5326c-1.8592,0.4387-10.0376,2.3073-13.4948,2.3073c-0.6685,0-1.1594-0.0627-1.4007-0.2298
		c-0.187-0.1254-0.2496-0.281-0.2716-0.3969c-1.221-5.3676-18.3402-98.0985-18.5073-99.0271l-0.0522-0.2726l0.2611-0.1044
		c6.8936-2.7784,14.1737-2.4232,14.2573-2.4232l0.2611,0.0219l19.2708,100.0517L344.7247,406.5326z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M383.9766,106.9517c-1.525,5.3896-2.9778,10.7583-4.3764,16.0956
		c-1.8185-2.9141-9.7138-14.8955-20.6809-22.1118c-15.3958-10.1316-32.0971-16.2209-52.4856-19.1351
		c0.187-0.2308,0.376-0.4606,0.5432-0.6894c0.6058-0.7938,1.0236-1.4309,1.3568-2.0994l0.0533-0.094
		c0.8565-1.713-0.188-4.6062-0.7416-5.9014c5.4105,1.4508,40.8291,11.1029,52.2966,16.8372
		C372.1843,95.9741,383.5588,105.7505,383.9766,106.9517"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M379.4855,123.4758c-3.5722,13.6504-6.7485,27.1348-9.5571,40.5565
		c-0.9192-1.3578-2.6112-3.3831-5.3488-4.9613c-4.2928-2.4754-76.0378-8.3141-104.5837-4.0829l0.0199-61.814
		c2.3501,0.4188,4.7942,0.586,7.1558,0.7312l1.1385,0.0741c3.4155,0.2193,6.3923,0.2716,9.1174,0.1556
		c7.4054-0.3134,14.0901-2.0159,19.8568-5.0752c2.3083-1.2231,4.3973-2.653,6.2032-4.2302
		c0.8889-0.7729,1.7025-1.5887,2.4337-2.4232c20.473,2.8818,37.2047,8.9513,52.6318,19.1037
		c11.1656,7.3428,19.1455,19.7398,20.6287,22.1537L379.4855,123.4758z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M251.7854,93.4253l-0.0209,61.5518c-28.5971-4.2103-100.1979,1.6179-104.4908,4.0944
		c-3.5408,2.0472-5.7029,4.8255-6.4758,5.9536c-2.8306-13.6724-6.058-27.397-9.6929-41.2782l0.1368,0.0731
		c0.8972-1.4832,9.1591-14.696,20.7321-22.3103c15.4271-10.1514,32.1494-16.2209,52.6214-19.1037
		c1.1803,1.3474,2.5694,2.6217,4.1571,3.8228c4.3869,3.2901,9.9655,5.6716,16.1374,6.8832
		c1.7965,0.3551,3.7079,0.6162,5.6925,0.7938c5.6507,0.5118,11.8978,0.4282,19.1037-0.2611
		C250.3858,93.581,251.0856,93.5089,251.7854,93.4253"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M204.0948,81.7901c-20.3895,2.9246-37.0909,9.014-52.4971,19.1455
		c-10.9149,7.1861-18.6849,18.9147-20.6705,22.1118c-1.3996-5.3373-2.8504-10.6956-4.3754-16.0851
		c0.5118-1.2962,11.8341-11.0089,24.0337-17.1088c11.457-5.7353,46.8757-15.3864,52.2976-16.8372
		c-0.5536,1.2952-1.5981,4.1874-0.7426,5.9014c0.3562,0.7103,0.8147,1.4195,1.4424,2.2561
		C203.7502,81.3817,203.9277,81.5813,204.0948,81.7901"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M463.9117,459.1428v0.0104c-29.2886,10.1107-44.4546,9.0453-50.8886,7.5099
		c-0.4585-0.1034-0.6476-0.5421-0.6789-0.9192c-0.0209-0.3865,0.1044-0.8983,0.5755-1.0863
		c13.4844-5.493,25.9869-6.9448,35.4187-6.9448C455.7856,457.7129,461.3214,458.6101,463.9117,459.1428"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M463.6292,458.3909c-6.4445-1.2534-27.1985-4.0526-50.9607,5.6298
		c-0.2298,0.093-0.4178,0.2611-0.5745,0.4492c-0.3561-1.8697-1.0236-5.4836-1.9114-10.1629
		c2.5694-1.5145,5.3781-2.8306,8.6056-4.0004c3.2076-1.1594,6.6022-2.0994,10.3624-2.8723c2.8305-0.5849,5.7656-1.0445,8.711-1.3683
		c0.8878-0.094,1.7756-0.1671,2.6635-0.2308c0.6162-0.0512,1.2325-0.093,1.8477-0.1556c4.4819-0.4074,9.0777-0.2925,14.0599,0.376
		c2.3908,0.3134,4.4798,0.658,6.4027,1.0549C463.2625,452.8447,463.5456,457.0634,463.6292,458.3909"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M462.7836,446.4109c-1.8812-0.3865-3.9283-0.7207-6.2669-1.0341
		c-5.0251-0.6685-9.673-0.7834-14.2061-0.3656c-0.6058,0.0522-1.2221,0.094-1.8373,0.1462
		c-0.2935,0.0209-0.5849,0.0522-0.8773,0.0731c-7.3636-55.4624-32.1599-159.3892-32.4011-160.3501
		c0-0.282-13.0342-60.6953-36.3796-119.3121v-0.0209c-0.1034-0.2611-0.2078-0.5128-0.3133-0.7625l-0.0313,0.0105
		c3.8865-18.7392,8.5136-37.5912,13.9335-56.8307c0.3666,0.658,1.0236,1.6921,2.089,3.3727
		c3.123,4.8997,8.9314,14.0285,13.193,23.9617c3.6557,8.5439,12.8253,41.9248,20.19,68.7483
		c5.2747,19.2081,9.8391,35.7842,11.1447,38.8341c3.1335,7.3208,16.67,84.352,17.725,95.9886
		c1.0539,11.5416,5.2005,41.7274,8.3653,54.3657C459.2626,401.8321,461.572,429.8965,462.7836,446.4109"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M342.9906,399.3671c-10.5504-36.8914-14.978-71.2979-16.4925-85.6377L342.9906,399.3671z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M344.2228,405.9573c-6.4445,1.4936-13.3695,2.6749-13.9951,2.1203
		c-1.1918-5.2224-17.4221-93.1267-18.4561-98.7461c5.8898-2.2979,12.0116-2.3083,13.4112-2.2759
		C325.5055,311.2012,329.4641,357.3154,344.2228,405.9573"
        />
        <path
          fill={darkenColor}
          d="M309.6189,48.7316c-0.7103,1.6085-5.9421,12.983-14.3826,13.547
		c-9.2322,0.6058-22.279-0.376-22.3824-0.3865c-0.3979-0.0522-9.6417-1.3578-11.3954-0.9609
		c-1.5364,0.3447-2.0587,1.7756-2.1109,2.5068l-0.1149,391.3913c-3.4886-0.3447-5.9745-0.0522-6.925,0.1045
		c0.0522-0.6789,0.0627-1.3578,0.0627-2.0263l0.1045-389.4694l-0.0209-0.1149c-0.0209-0.0627-0.5849-1.5458-2.559-2.0054
		c-1.8477-0.4387-12.4597,0.5337-12.9099,0.5745c-0.1253,0.0105-12.4608,0.9923-21.694,0.3865
		c-8.4813-0.564-13.8708-11.6878-14.5498-13.171c1.1489-2.6739,3.5314-4.0735,5.5368-4.7733
		c3.1638-1.1072,6.6116-1.7756,9.953-2.4128c0.7938-0.1462,1.5772-0.3039,2.3605-0.4596c1.3892-0.2715,2.7679-0.5431,4.1571-0.7938
		c7.4368-1.3683,14.3419-2.2979,21.0987-2.8306c8.0635-0.6476,15.636-0.6894,22.4983-0.1253
		c4.9718,0.4074,9.9749,1.2638,14.8109,2.0994c2.4545,0.4178,4.9926,0.846,7.5099,1.222c0.9714,0.1462,2.0378,0.2716,3.1658,0.4074
		C298.1932,42.214,306.5168,43.248,309.6189,48.7316"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M140.2973,165.944c-23.2399,58.481-36.224,118.6551-36.2125,118.8525
		c-0.2611,1.0445-25.3717,104.9932-32.703,160.4128c-3.0081-0.3228-5.7969-0.4909-8.4081-0.5003
		c-2.0796,0-4.3137,0.1358-6.9981,0.4272c-2.9047,0.3238-5.6716,0.7531-8.2421,1.2753c1.2231-16.5144,3.5314-44.5788,5.682-53.176
		c3.1554-12.6373,7.3114-42.8241,8.3559-54.3647c1.0664-11.6367,14.603-88.6678,17.7365-95.9897
		c1.3056-3.0499,5.8596-19.6259,11.1332-38.8341c7.3751-26.8225,16.5343-60.2034,20.2015-68.7483
		c4.2605-9.9331,10.0678-19.0619,13.1815-23.9606c1.0748-1.6816,1.7224-2.7156,2.0994-3.3737
		C131.6489,127.6007,136.3491,146.8194,140.2973,165.944"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M100.3344,454.3069c-0.8774,4.6793-1.5553,8.2933-1.8999,10.1629
		c-0.1577-0.188-0.3447-0.3551-0.5755-0.4491c-23.7621-9.6824-44.5151-6.8832-50.9711-5.6298
		c0.095-1.3265,0.376-5.5452,0.7949-11.2805c2.6112-0.5316,5.4199-0.9703,8.3664-1.2952c2.6624-0.2924,4.8349-0.4282,6.9239-0.4282
		c4.2406,0.0209,8.921,0.4387,14.32,1.3056c5.1389,0.8147,9.7242,1.9532,14.0077,3.4677
		C94.7046,451.3625,97.6605,452.7192,100.3344,454.3069"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M98.173,465.7442c-0.0313,0.376-0.2204,0.8147-0.6695,0.9192c-6.4341,1.5354-21.5896,2.6008-50.8353-7.5308
		c5.9755-1.2116,26.9061-4.272,50.9293,5.5254C98.0675,464.846,98.2033,465.3578,98.173,465.7442"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M198.8724,309.3319c-1.034,5.6194-17.2769,93.5236-18.4353,98.7148
		c-0.6486,0.5849-7.5726-0.5964-14.0171-2.089c14.7587-48.6523,18.7068-94.7666,19.04-98.9027
		C186.8388,307.034,192.971,307.0236,198.8724,309.3319"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M184.1445,313.7291c-1.5145,14.3304-5.9431,48.7463-16.4925,85.6377L184.1445,313.7291z"
        />
        <path
          fill="#010101"
          d="M199.3838,308.8093c-6.8936-2.7783-14.1842-2.4232-14.2573-2.4232l-0.2611,0.0209l-19.2082,99.7279
		l-0.0627,0.3238l0.3133,0.0742c1.8696,0.4387,10.048,2.3073,13.5052,2.3073c0.658,0,1.149-0.0731,1.3892-0.2298
		c0.1985-0.1253,0.2611-0.2809,0.2705-0.376c1.2221-5.3885,18.3423-98.1194,18.5199-99.0479l0.0522-0.2726L199.3838,308.8093z
		 M184.1447,313.7289c-1.5145,14.3304-5.9442,48.7464-16.4925,85.6378L184.1447,313.7289z M180.4367,408.0463
		c-0.6476,0.586-7.5726-0.5954-14.0171-2.089c14.7587-48.6523,18.7068-94.7655,19.0411-98.9017
		c1.3787-0.0219,7.5099-0.0324,13.4113,2.2759C197.8379,314.9509,181.595,402.8552,180.4367,408.0463"
        />
        <path
          fill="#010101"
          d="M325.7777,306.4073l-0.2611-0.0209c-0.0836,0-7.3647-0.3551-14.2573,2.4232l-0.2611,0.1045l0.0522,0.2715
		c0.1671,0.9296,17.2853,93.6594,18.5073,99.0281c0.0219,0.1149,0.0836,0.2716,0.2716,0.3969
		c0.2413,0.1671,0.7322,0.2287,1.4007,0.2287c3.4572,0,11.6356-1.8686,13.4948-2.3062l0.3228-0.0742L325.7777,306.4073z
		 M342.9909,399.3669c-10.5504-36.8914-14.978-71.2979-16.4925-85.6377L342.9909,399.3669z M330.2272,408.0779
		c-1.1918-5.2224-17.4221-93.1267-18.4561-98.7461c5.8909-2.2979,12.0116-2.3083,13.4113-2.277
		c0.3227,4.1466,4.2824,50.2598,19.04,98.9027C337.7778,407.4502,330.8539,408.6315,330.2272,408.0779"
        />
        <rect x="255.1076" y="412.005" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1086" y="410.4042" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1096" y="408.8041" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1258" y="411.2125" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1263" y="409.6121" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1274" y="408.0116" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1015" y="424.8204" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1025" y="423.22" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1033" y="421.62" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.104" y="420.0182" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1045" y="418.4178" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1055" y="416.8174" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1065" y="415.2173" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1071" y="413.6165" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1196" y="424.0278" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1205" y="422.4274" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1212" y="420.8271" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1226" y="419.227" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1228" y="417.6263" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1236" y="416.0257" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1243" y="414.4245" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1257" y="412.8243" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.095" y="437.632" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.0963" y="436.0313" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.0971" y="434.4306" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.0979" y="432.8306" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.0981" y="431.2303" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.0994" y="429.6287" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1002" y="428.029" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1009" y="426.428" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1136" y="436.8391" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1146" y="435.2388" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1152" y="433.6384" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1163" y="432.0377" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1166" y="430.4376" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1173" y="428.8374" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1182" y="427.2368" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1194" y="425.636" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.0898" y="450.4267" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.0903" y="448.8263" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.0908" y="447.2256" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.0918" y="445.6256" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.0918" y="444.0243" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.0933" y="442.4237" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.0939" y="440.8239" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.0948" y="439.223" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1079" y="449.6342" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1084" y="448.0338" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.109" y="446.4334" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.11" y="444.8327" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1105" y="443.2325" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1115" y="441.6322" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.112" y="440.0318" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1132" y="438.43" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1827" y="253.4038" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1835" y="251.8032" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1841" y="250.2029" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2008" y="252.6112" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2019" y="251.0109" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2023" y="249.4103" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1764" y="266.2197" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1774" y="264.6187" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1775" y="263.0183" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.179" y="261.4168" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1796" y="259.817" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.1805" y="258.2161" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1811" y="256.6157" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1821" y="255.0153" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1946" y="265.4265" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1957" y="263.8257" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1962" y="262.2258" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1967" y="260.6254" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1978" y="259.025" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1988" y="257.4251" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1992" y="255.8232" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1999" y="254.2227" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="255.1712" y="279.0304" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1713" y="277.43" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1723" y="275.83" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1729" y="274.2292" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1744" y="272.6277" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1744" y="271.0274" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1754" y="269.4273" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1759" y="267.8267" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1886" y="278.2378" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1894" y="276.6375" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.19" y="275.0371" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1911" y="273.4367" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1916" y="271.8362" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1925" y="270.2357" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1932" y="268.6355" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1941" y="267.0341" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.165" y="291.8254" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1652" y="290.225" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1662" y="288.6246" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1667" y="287.0242" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1681" y="285.4226" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1683" y="283.8224" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1692" y="282.222" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1698" y="280.6216" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1824" y="291.0328" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1835" y="289.4324" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1842" y="287.8323" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1849" y="286.2317" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1855" y="284.6313" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1863" y="283.0308" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1873" y="281.4306" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.188" y="279.8291" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1586" y="304.6245" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1597" y="303.0244" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.16" y="301.4237" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1606" y="299.8233" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1616" y="298.2229" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1629" y="296.6227" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1632" y="295.0222" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1637" y="293.4207" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1758" y="303.8328" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1773" y="302.2315" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1779" y="300.6315" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1789" y="299.0308" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1794" y="297.4303" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1804" y="295.83" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.181" y="294.2298" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1819" y="292.6292" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1524" y="317.4399" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1535" y="315.8392" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.154" y="314.2391" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1545" y="312.6389" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1556" y="311.0384" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1566" y="309.4376" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.157" y="307.8375" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1576" y="306.2361" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1707" y="316.6484" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1712" y="315.047" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1727" y="313.4463" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1727" y="311.8462" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1738" y="310.246" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1743" y="308.6453" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1748" y="307.0446" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1758" y="305.4446" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1464" y="330.2512" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1472" y="328.651" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1478" y="327.0504" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1482" y="325.4506" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1494" y="323.8496" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1503" y="322.2493" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.151" y="320.6488" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1514" y="319.049" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1646" y="329.4597" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1651" y="327.8593" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1664" y="326.2591" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1666" y="324.6575" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1676" y="323.0571" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1681" y="321.4567" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1696" y="319.8564" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1697" y="318.2559" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1402" y="343.0738" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1409" y="341.4731" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1418" y="339.873" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1427" y="338.2715" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1432" y="336.6712" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1441" y="335.0704" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1448" y="333.4703" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1459" y="331.87" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1585" y="342.2813" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.159" y="340.6808" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.16" y="339.0804" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1612" y="337.48" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.1615" y="335.8797" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1621" y="334.2792" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1633" y="332.6775" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1635" y="331.0774" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1342" y="355.8729" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1351" y="354.2724" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1357" y="352.6721" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1366" y="351.0717" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1372" y="349.4713" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1378" y="347.8706" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1388" y="346.2694" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1397" y="344.669" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1523" y="355.0814" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1528" y="353.4795" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1539" y="351.8795" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1549" y="350.2792" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1553" y="348.6787" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1559" y="347.0783" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1569" y="345.4779" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1581" y="343.8775" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1284" y="368.6884" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.129" y="367.0879" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1305" y="365.488" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1305" y="363.887" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.131" y="362.2867" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1321" y="360.6863" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1326" y="359.0864" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1336" y="357.4844" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1462" y="367.8967" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1466" y="366.2954" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1478" y="364.6949" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1487" y="363.0951" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1493" y="361.4941" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1497" y="359.8937" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1508" y="358.2933" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1518" y="356.6934" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1221" y="381.5001" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1229" y="379.8992" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1242" y="378.2987" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1244" y="376.6983" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1253" y="375.0984" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1259" y="373.4976" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1274" y="371.897" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1275" y="370.2968" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1401" y="380.708" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1412" y="379.1077" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1417" y="377.5062" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1424" y="375.9058" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1431" y="374.3054" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1442" y="372.705" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1447" y="371.1047" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1455" y="369.5041" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1163" y="394.2946" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1168" y="392.6942" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.118" y="391.0937" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1183" y="389.4933" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1193" y="387.893" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1198" y="386.2926" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1211" y="384.692" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1213" y="383.0908" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.134" y="393.5033" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.135" y="391.9016" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1355" y="390.3012" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1361" y="388.7008" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1372" y="387.1006" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.138" y="385.5" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1385" y="383.8997" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1393" y="382.2991" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1101" y="407.0947" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1107" y="405.4943" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1117" y="403.8929" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1127" y="402.2927" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1132" y="400.692" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1137" y="399.0917" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1148" y="397.4912" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="255.1152" y="395.8908" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1288" y="406.3025" fill="#010101" width="2.3982" height="0.6915" />
        <rect x="254.1288" y="404.7017" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.1293" y="403.1014" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1304" y="401.5009" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.1309" y="399.9008" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.132" y="398.2991" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.1325" y="396.6988" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.1334" y="395.0984" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2579" y="94.8022" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2585" y="93.2019" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.26" y="91.6008" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2758" y="94.0098" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2761" y="92.4093" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2773" y="90.809" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2517" y="107.6181" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2524" y="106.0174" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2537" y="104.4157" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.254" y="102.8155" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2548" y="101.2154" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="255.2555" y="99.6148" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2569" y="98.014" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.257" y="96.4139" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2696" y="106.8252" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2707" y="105.2248" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2712" y="103.6245" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2719" y="102.0238" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2727" y="100.4236" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2737" y="98.8222" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2742" y="97.2219" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2751" y="95.6211" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2458" y="120.4291" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2463" y="118.8287" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2475" y="117.2284" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2478" y="115.6278" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2488" y="114.0265" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2494" y="112.4261" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2506" y="110.8257" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2509" y="109.2253" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2636" y="119.6371" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2645" y="118.0361" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.265" y="116.4358" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2657" y="114.8355" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2667" y="113.2353" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2676" y="111.6346" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2682" y="110.0342" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2688" y="108.4328" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2396" y="133.2241" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2402" y="131.6237" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2412" y="130.0233" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2423" y="128.4222" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2427" y="126.8215" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2432" y="125.2211" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2443" y="123.6207" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2448" y="122.0203" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2583" y="132.4321" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2584" y="130.8311" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.259" y="129.2308" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2599" y="127.6304" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2615" y="126.0303" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2615" y="124.4296" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.262" y="122.8282" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.263" y="121.2278" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2336" y="146.0231" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2339" y="144.4228" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="255.235" y="142.8224" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.236" y="141.2224" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2366" y="139.6216" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2372" y="138.0212" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2382" y="136.4198" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2391" y="134.8197" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2521" y="145.2312" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2523" y="143.6302" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2531" y="142.0299" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="254.2539" y="140.4295" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2552" y="138.8296" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2553" y="137.2286" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2563" y="135.6282" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2569" y="134.0279" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2274" y="158.8386" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2276" y="157.2387" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="255.229" y="155.6378" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2297" y="154.0373" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2305" y="152.437" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2308" y="150.837" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.232" y="149.2352" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2329" y="147.6346" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2458" y="158.0471" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2461" y="156.4456" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2472" y="154.8452" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2477" y="153.2448" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2489" y="151.6444" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2493" y="150.044" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2502" y="148.4436" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2507" y="146.8433" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2213" y="171.6499" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2223" y="170.0495" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2228" y="168.4491" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2234" y="166.849" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2244" y="165.2483" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2253" y="163.6479" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2259" y="162.0475" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2266" y="160.4473" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2395" y="170.8584" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2406" y="169.2576" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2411" y="167.6565" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2417" y="166.0561" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2427" y="164.4561" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2437" y="162.8559" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2441" y="161.2549" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2447" y="159.6546" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2161" y="184.4727" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2162" y="182.872" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2168" y="181.2717" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2182" y="179.6701" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2193" y="178.07" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2193" y="176.4694" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2198" y="174.869" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2203" y="173.2685" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2334" y="183.6799" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2343" y="182.0798" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2349" y="180.4791" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2355" y="178.8787" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2365" y="177.2783" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2375" y="175.6771" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.238" y="174.0765" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2385" y="172.4761" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2099" y="197.2719" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2101" y="195.6711" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2106" y="194.0707" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2117" y="192.4704" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.213" y="190.8702" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2131" y="189.2695" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2137" y="187.6681" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2147" y="186.0677" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2273" y="196.479" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2281" y="194.879" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2288" y="193.2782" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2291" y="191.6776" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="254.2304" y="190.0774" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2312" y="188.4772" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2319" y="186.8766" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2322" y="185.2759" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2036" y="210.0867" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.2039" y="208.4866" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.2047" y="206.8864" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2055" y="205.2857" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.2067" y="203.685" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.207" y="202.085" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2078" y="200.4837" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="255.2085" y="198.8831" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2212" y="209.2944" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2218" y="207.6938" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2227" y="206.0937" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2238" y="204.4932" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2243" y="202.8928" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2249" y="201.2921" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2258" y="199.692" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.226" y="198.0918" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1973" y="222.8984" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.1979" y="221.2979" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1989" y="219.6975" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1994" y="218.097" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.2005" y="216.4968" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.2009" y="214.8963" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2015" y="213.2964" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.2025" y="211.6954" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2151" y="222.1067" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2166" y="220.5065" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2176" y="218.9054" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2176" y="217.3045" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2181" y="215.7041" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2187" y="214.1039" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2197" y="212.5034" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.2206" y="210.9029" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1912" y="235.6932" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1921" y="234.0933" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.1927" y="232.4925" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1933" y="230.892" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1942" y="229.2918" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="255.1947" y="227.6913" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1958" y="226.0909" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1963" y="224.4895" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2089" y="234.9017" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.21" y="233.3003" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2113" y="231.7004" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2114" y="230.0995" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="254.212" y="228.4991" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.213" y="226.8987" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2145" y="225.2986" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2146" y="223.6979" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1851" y="248.4933" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="255.1858" y="246.8925" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.1866" y="245.2916" fill="#010101" width="2.3992" height="0.6915" />
        <rect x="255.1871" y="243.6911" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.1881" y="242.0907" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="255.189" y="240.4908" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="255.1897" y="238.89" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="255.1902" y="237.2895" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.203" y="247.7009" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="254.2038" y="246.1004" fill="#010101" width="2.3981" height="0.6904" />
        <rect x="254.2051" y="244.5005" fill="#010101" width="2.3982" height="0.6904" />
        <rect x="254.2054" y="242.8996" fill="#010101" width="2.3992" height="0.6904" />
        <rect x="254.2061" y="241.2982" fill="#010101" width="2.3992" height="0.6914" />
        <rect x="254.207" y="239.6978" fill="#010101" width="2.3981" height="0.6915" />
        <rect x="254.2082" y="238.0979" fill="#010101" width="2.3982" height="0.6914" />
        <rect x="254.2084" y="236.497" fill="#010101" width="2.3992" height="0.6915" />
        <path
          fill="#010101"
          d="M257.5313,67.9742c-0.0104-0.3374-0.2966-0.6173-0.635-0.6173h-0.0094v0.6486h0.1065l0.2392,2.9246h-2.6175
		l0.2413-2.9246h0.1086v-0.6486h-0.0501c-0.3405,0-0.6277,0.2799-0.6351,0.6173l-0.376,21.6272
		c-0.0115,0.3374,0.258,0.6173,0.5985,0.6173h2.8253c0.3405,0,0.61-0.2799,0.5985-0.6173L257.5313,67.9742z M254.732,73.0378
		c0.0011-0.2308,0.187-0.4136,0.4136-0.4136h1.5406c0.2267,0,0.4126,0.1828,0.4126,0.4136l-0.0011,1.5386
		c0,0.2298-0.187,0.4126-0.4126,0.4126h-1.5406c-0.2267,0-0.4126-0.1828-0.4126-0.4126V73.0378z M255.9154,89.5147
		c-0.7531,0-1.3631-0.61-1.362-1.3631c0-0.7499,0.61-1.3599,1.3631-1.3599c0.7531,0,1.362,0.61,1.362,1.3599
		C257.2774,88.9047,256.6685,89.5147,255.9154,89.5147"
        />
        <rect x="255.2048" y="65.5214" fill="#010101" width="1.4404" height="3.5523" />
        <path
          fill="#010101"
          d="M259.0479,66.4022c0.001-1.6367-1.3255-2.9653-2.9611-2.9653h-0.3196
		c-1.6357,0-2.9632,1.3286-2.9643,2.9653c0,0.304,0.0459,0.5975,0.1316,0.8742h-0.001c0.001,0.0021,0.001,0.0052,0.0021,0.0073
		c0,0,0.001,0.001,0.001,0.0021c0.2935,0.7719,0.2914,1.8979,0.2904,2.9758h0.0073c0.0366,0.5933,0.3175,1.1187,0.7437,1.479
		l0.1285-4.0035c0.0104-0.352,0.3269-0.6403,0.7008-0.6403h0.1577l0.001-1.8268h1.9219l-0.001,1.8268h0.1118
		c0.3739,0,0.6904,0.2883,0.7029,0.6403l0.1389,4.0286c0.4418-0.3614,0.7364-0.8972,0.774-1.5041h0.0042v-0.0856
		c0.001-0.0156,0.0031-0.0313,0.0031-0.048c0-0.0146-0.0021-0.0293-0.0031-0.0449c0.0021-0.9985,0.0167-2.0169,0.2758-2.7439
		C258.9925,67.0446,259.0479,66.7291,259.0479,66.4022"
        />
        <rect x="254.3555" y="451.3441" fill="#010101" width="3.0666" height="1.3557" />
        <path
          fill="#010101"
          d="M256.3489,456.9742h-0.9254c-0.9829,0-1.7809-0.799-1.7798-1.7829l0.0011-2.2592h4.4871l-0.001,2.2592
		C258.1308,456.1751,257.3328,456.9742,256.3489,456.9742"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M100.9515,452.5667c-3.0008-1.8226-6.2273-3.2609-9.5341-4.4286c-4.5634-1.6117-9.2991-2.724-14.0755-3.4855l-4.4715-0.6434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M47.3612,445.1257c2.8556-0.5933,5.7541-1.0299,8.6515-1.3516c2.3104-0.2559,4.6354-0.4314,6.9605-0.4241
		c2.8828,0.0094,5.7969,0.2068,8.6922,0.5275"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M409.5717,452.5667c3.0008-1.8226,6.2272-3.2609,9.5341-4.4286c4.5634-1.6117,9.2991-2.724,14.0755-3.4855l4.4715-0.6434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M463.162,445.1257c-2.8557-0.5933-5.7541-1.0299-8.6515-1.3516c-2.3104-0.2559-4.6354-0.4314-6.9605-0.4241
		c-2.8818,0.0094-5.7969,0.2068-8.6923,0.5275"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M139.3701,164.2783c-23.6483,59.3845-37.0366,120.5979-37.0366,120.5989c0,0-24.6061,101.5693-32.3886,158.1086"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M140.7533,163.0798c0,0,1.6712-3.0927,6.0915-5.6455c4.4203-2.5538,77.2641-8.1846,104.6913-3.9952"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M372.2995,164.2783c23.6472,59.3845,37.0355,120.5979,37.0355,120.5989c0,0,25.3864,104.7895,32.7448,160.7418"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M370.9164,163.0798c0,0-1.6712-3.0927-6.0915-5.6455c-4.4203-2.5538-77.2651-8.1846-104.6913-3.9952"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M179.3158,410.8392c-3.7873,0-12.3125-1.9605-13.9836-2.3532l-2.2133-0.5107l0.3698-2.2571l19.5309-101.4189l1.9229-0.0794
		c0.3248-0.0198,0.8283-0.0209,1.0017-0.0209c2.3094,0,8.3079,0.2517,14.1194,2.582l1.8383,0.7646l-0.3635,1.9355
		c-0.14,0.7907-17.3135,93.791-18.5251,99.1263c-0.1368,0.6309-0.5233,1.2106-1.0842,1.6169
		C181.247,410.6721,180.4898,410.8392,179.3158,410.8392z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M331.1054,410.8392c3.7873,0,12.3124-1.9605,13.9836-2.3532l2.2133-0.5107l-0.3698-2.2571l-19.5309-101.4189l-1.9229-0.0794
		c-0.3249-0.0198-0.8283-0.0209-1.0017-0.0209c-2.3094,0-8.3079,0.2517-14.1194,2.582l-1.8383,0.7646l0.3635,1.9355
		c0.1399,0.7907,17.3134,93.791,18.5251,99.1263c0.1368,0.6309,0.5233,1.2106,1.0842,1.6169
		C329.1741,410.6721,329.9314,410.8392,331.1054,410.8392z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M203.3339,49.1385c0.9902-1.5511,2.6143-2.3929,3.8886-2.8368c3.0144-1.056,6.3777-1.6983,9.6302-2.3198
		c0,0,1.9783-0.3812,2.4065-0.4669c1.3745-0.281,2.7533-0.54,4.131-0.7991c7.3835-1.3505,14.2144-2.2666,20.871-2.8023
		c4.1915-0.3353,8.3037-0.5055,12.2184-0.5055c3.4427,0,6.7903,0.1316,9.9509,0.3917c4.8287,0.3948,9.7284,1.2304,14.4662,2.0399
		l1.1876,0.2016c2.1516,0.3656,4.3472,0.7374,6.5186,1.0633c1.0153,0.14,2.0932,0.2778,3.2223,0.4147
		c5.3791,0.6538,12.6174,1.5344,15.6496,5.3843"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M201.4643,55.0831c2.9392,3.8082,7.3375,9.2406,13.0728,9.6208c2.1109,0.141,4.5394,0.211,7.2195,0.211
		c7.9057,0,15.3592-0.6037,15.4334-0.61c2.8306-0.258,8.3507-0.6914,11.2063-0.6914c0.8983,0,1.1604,0.046,1.1709,0.048
		c0.1943,0.046,0.3342,0.1128,0.4324,0.1818l-0.0104,27.3301c-0.0867,0.0084-0.1734,0.0146-0.259,0.024
		c-4.1957,0.3969-7.9684,0.5891-11.55,0.5891c-2.6175,0-5.1525-0.1086-7.535-0.3217c-1.9877-0.1817-3.8489-0.4449-5.5306-0.7802
		c-5.9087-1.15-11.223-3.4082-15.3801-6.5375c-1.9114-1.4362-3.5053-2.9904-4.7399-4.6208
		c-0.5358-0.7029-0.916-1.2941-1.2022-1.8707"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M141.4897,160.2666c-2.5684-11.9677-5.4658-24.1131-8.6338-36.1801c1.7976-2.8034,9.554-14.3074,19.886-21.0465
		c15.0187-9.7942,31.2887-15.7258,51.1236-18.6232"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          x1="250.2677"
          y1="94.8075"
          x2="250.2478"
          y2="151.6476"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M127.6095,106.9671c0,0,1.9668,6.3871,3.8688,13.5199"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M382.3916,106.9671c0,0-1.9658,6.3871-3.8678,13.5199"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          x1="250.2677"
          y1="156.6966"
          x2="250.0473"
          y2="453.5647"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M249.1599,450.1299c-1.6284,0.187-3.356,0.0554-4.9509-0.0616c-2.1182-0.1535-4.2218-0.4397-6.3317-0.6726
		c-2.0211-0.2225-4.0422-0.445-6.0622-0.6674c-2.7804-0.305-5.5598-0.611-8.3392-0.9171c-3.2609-0.3582-6.5218-0.7165-9.7816-1.0758
		l-10.3979-1.1447c-3.3936-0.3729-6.7881-0.7468-10.1817-1.1197c-3.0457-0.3343-6.0915-0.6706-9.1361-1.0048
		c-2.4211-0.2674-4.8412-0.5337-7.2613-0.8c-1.5197-0.1671-3.0384-0.3332-4.5571-0.5003c-0.3802-0.0418-0.7604-0.0836-1.1416-0.1253
		c-3.9785-0.4376-7.8702-1.4612-11.5333-3.0708c-4.4777-1.9668-9.7388-4.9592-11.1729-8.5847"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M249.369,446.3345c-1.4769,0.1118-3.0154-0.0052-4.4474-0.1086c-2.1172-0.1556-4.2218-0.4408-6.3306-0.6737
		c-2.0221-0.2225-4.0422-0.445-6.0643-0.6674c-2.7794-0.305-5.5577-0.611-8.3371-0.9171c-3.2609-0.3583-6.5228-0.7176-9.7837-1.0758
		c-3.4656-0.3812-6.9302-0.7625-10.3969-1.1447c-3.3946-0.3729-6.7881-0.7458-10.1817-1.1197
		c-3.0457-0.3353-6.0915-0.6695-9.1372-1.0059l-7.2613-0.798c-1.5177-0.1682-3.0363-0.3343-4.555-0.5014
		c-0.3813-0.0418-0.7625-0.0836-1.1427-0.1264c-3.9785-0.4377-7.8692-1.4592-11.5343-3.0698
		c-5.1963-2.2833-11.4497-5.9473-11.5479-10.3812"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M309.8148,53.8724c-2.3397,4.062-6.9532,10.1034-12.6874,10.4836c-2.112,0.14-4.2678,0.5588-6.948,0.5588
		c-7.9057,0-15.3592-0.6037-15.4334-0.61c-2.8306-0.258-8.3507-0.6914-11.2063-0.6914c-0.8983,0-1.1605,0.046-1.1709,0.048
		c-0.1943,0.046-0.3342,0.1128-0.4324,0.1818l0.0104,27.3301c0.0867,0.0083,0.1734,0.0157,0.259,0.024
		c4.1957,0.3969,7.9684,0.5891,11.55,0.5891c2.6165,0,5.1525-0.1086,7.5339-0.3217c1.9887-0.1818,3.6328-0.5066,5.3144-0.8408
		c5.9087-1.151,10.471-3.8991,14.6281-7.0273c1.9114-1.4362,3.193-2.9695,4.4266-4.5999c0.5358-0.7019,0.916-1.2952,1.2022-1.8696"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M369.3895,159.6169c2.5684-11.9677,5.165-23.6713,8.3329-35.7383c-1.7976-2.8034-9.554-14.3074-19.8871-21.0465
		c-15.0177-9.7942-31.2887-15.7258-51.1226-18.6232"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          x1="261.6683"
          y1="94.8075"
          x2="261.6881"
          y2="151.6476"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          x1="261.6683"
          y1="156.6966"
          x2="261.8887"
          y2="453.5647"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M262.7761,450.1299c1.6284,0.187,3.356,0.0554,4.9509-0.0616c2.1182-0.1535,4.2218-0.4397,6.3317-0.6726
		c2.0201-0.2225,4.0422-0.445,6.0622-0.6674c2.7804-0.305,5.5598-0.611,8.3392-0.9171c3.2609-0.3582,6.5218-0.7165,9.7816-1.0758
		l10.3979-1.1447c3.3936-0.3729,6.7882-0.7468,10.1817-1.1197c3.0457-0.3343,6.0915-0.6706,9.1362-1.0048
		c2.4211-0.2674,4.8412-0.5337,7.2613-0.8c1.5197-0.1671,3.0384-0.3332,4.5571-0.5003c0.3802-0.0418,0.7604-0.0836,1.1416-0.1253
		c3.9785-0.4376,7.8702-1.4612,11.5333-3.0708c4.4778-1.9668,9.7388-4.9592,11.1729-8.5847"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M262.567,446.3345c1.4769,0.1118,3.0154-0.0052,4.4474-0.1086c2.1172-0.1556,4.2218-0.4408,6.3307-0.6737
		c2.0221-0.2225,4.0422-0.445,6.0643-0.6674c2.7794-0.305,5.5577-0.611,8.3371-0.9171c3.2609-0.3583,6.5228-0.7176,9.7837-1.0758
		c3.4656-0.3812,6.9302-0.7625,10.3969-1.1447c3.3946-0.3729,6.7881-0.7458,10.1817-1.1197
		c3.0457-0.3353,6.0915-0.6695,9.1372-1.0059l7.2613-0.798c1.5176-0.1682,3.0363-0.3343,4.555-0.5014
		c0.3812-0.0418,0.7625-0.0836,1.1427-0.1264c3.9785-0.4377,7.8692-1.4592,11.5343-3.0698
		c5.1963-2.2833,11.4497-5.9473,11.5479-10.3812"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M142.4648,165.7023c0,0,14.7001,67.6673,11.2951,93.509"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.47"
          strokeMiterlimit="10"
          strokeDasharray="1.4028,1.4017"
          d="
		M367.7411,165.7023c0,0-14.7001,67.6673-11.2951,93.509"
        />
        <path
          fill="#010101"
          d="M464.3285,458.6097c-0.2193-3.3517-3.5398-53.4664-6.5594-65.5313
		c-3.1533-12.6174-7.301-42.7405-8.3455-54.2602c-1.0654-11.6565-14.6333-88.8548-17.7867-96.1985
		c-1.2858-3.0071-5.8387-19.5738-11.1029-38.7495c-7.3752-26.8434-16.5458-60.2472-20.2318-68.8329
		c-4.272-9.9947-10.1002-19.1455-13.2337-24.0651c-1.2638-1.9845-2.3501-3.6975-2.4034-4.0098
		c0-1.4101-12.419-11.7192-24.4191-17.7145c-11.8654-5.9327-49.1025-16.0026-52.8-16.9949
		c0.5755-2.2446,1.0549-4.5331,1.5145-6.7463c0.2298-1.0978,0.4606-2.1934,0.6998-3.2901c0.1995-0.9087,0.4711-1.8498,0.7217-2.747
		c0.6779-2.372,1.3788-4.8255,1.055-7.3751c-1.1709-9.0871-11.7829-10.3812-19.533-11.3223
		c-1.1061-0.1347-2.1726-0.2705-3.1429-0.4063c-2.4963-0.3771-5.0355-0.8053-7.489-1.2325
		c-4.8579-0.8262-9.8715-1.6816-14.8641-2.1005c-6.9041-0.564-14.5069-0.5222-22.6226,0.1254
		c-6.7787,0.5431-13.6933,1.4738-21.1624,2.841c-1.3892,0.2507-2.7773,0.5222-4.1665,0.8053
		c-0.7729,0.1452-1.5667,0.3029-2.3616,0.4481c-3.3528,0.6486-6.831,1.3161-10.048,2.4441
		c-3.7393,1.3056-6.0058,3.803-6.5479,7.2174c-0.6382,4.0526,0.3123,8.1053,1.2314,12.0221l0.282,1.1698
		c0.6486,2.8003,1.338,5.5358,2.0587,8.147c-3.7403,1.0142-40.9336,11.0622-52.7896,16.9949
		c-12.0012,5.9954-24.4191,16.3045-24.4191,17.7041c-0.0533,0.3227-1.1489,2.0357-2.4138,4.0202
		c-3.123,4.9195-8.9502,14.0703-13.2337,24.0651c-3.6755,8.5857-12.8566,41.9895-20.2307,68.8329
		c-5.2653,19.1758-9.8088,35.7424-11.104,38.7495c-3.1439,7.3438-16.7223,84.5421-17.7762,96.1985
		c-1.0549,11.5197-5.2026,41.6428-8.3465,54.2602c-3.0175,12.0649-6.3401,62.1795-6.5584,65.5313
		c-0.1368,0.116-0.2308,0.282-0.2402,0.4805c-0.0209,0.3238,0.1567,0.6069,0.4387,0.6998
		c19.4798,6.7275,32.7657,8.5335,41.4245,8.5335c4.4287,0,7.6342-0.47,9.8391-1.0027c0.6256-0.1452,1.0643-0.6894,1.1583-1.3996
		l0.0313,0.0105c0.0324-0.187,0.9087-4.8778,2.2247-11.8748l0.0533-0.0836c-0.0115,0-0.022-0.0115-0.0313-0.0115
		c3.8333-20.2725,11.4152-59.7135,13.4833-65.5094c2.3616-6.5918,18.1741-64.9683,20.2109-76.1851
		c1.4738-8.0844,11.0089-36.8297,16.9521-52.8418c-0.1045,13.9032-1.0549,77.2505-1.0654,77.92l-2.0054,77.8761
		c-0.0094,0.1462-1.7234,14.1006-1.5563,21.4026c0.1045,4.6062,6.4445,8.3559,11.7505,10.6841
		c3.6557,1.6085,7.5726,2.653,11.6367,3.1032l66.8578,7.3532c0.6058,0.0616,1.222,0.1358,1.8279,0.2089
		c1.4727,0.1776,2.9977,0.3551,4.5122,0.469h0.094c0.9808,0.0742,2.0357,0.1473,3.0802,0.1473c0.9922,0,1.995-0.0637,2.9361-0.2726
		c0.3959-0.0825,0.9808-0.2392,1.4403-0.6256c0.6486-0.5327,0.8993-1.3474,0.9829-1.9438c0.0105-0.0303,0.0105-0.0721,0.0105-0.1139
		c0.751-0.1253,3.3528-0.5024,7.0398-0.1149c0.1462,0.564,0.6685,1.8488,2.4441,2.5068c0.6465,0.2392,1.3892,0.2392,2.0472,0.2392
		h0.4387c1.1061,0,2.2039-0.0616,3.217-0.1253c2.4117-0.1661,4.8454-0.4272,7.1955-0.6883l0.7635-0.0836
		c5.2329-0.586,10.4648-1.1395,15.6977-1.7036l18.7068-2.0159c3.0196-0.3228,6.1102-0.5954,9.0975-0.8669
		c7.8755-0.6894,16.0235-1.4195,23.8676-3.1429l0.8565-0.188c6.8519-1.4947,19.6051-4.272,19.7921-12.8264
		c0.1159-5.2444-0.7197-13.7977-1.2221-18.4363c-0.2287-2.0775-0.3749-4.2197-0.4283-6.3808l-1.9114-74.4617
		c-0.0105-0.6695-0.9714-64.0168-1.0748-77.92c5.9421,16.012,15.4897,44.7574,16.9625,52.8418
		c2.0357,11.2168,17.8389,69.5933,20.2004,76.1851c2.0775,5.7959,9.6615,45.2369,13.4948,65.5094
		c-0.0104,0-0.0219,0.0115-0.0313,0.0115l0.0418,0.0836c1.3255,6.997,2.1924,11.6878,2.2342,11.8748l0.0219-0.0105
		c0.1034,0.7103,0.5421,1.2545,1.1688,1.3996c2.1934,0.5327,5.4115,1.0027,9.8391,1.0027c8.6494,0,21.9458-1.8059,41.4245-8.5335
		c0.282-0.093,0.4596-0.376,0.4387-0.6998C464.5583,458.8918,464.4643,458.7257,464.3285,458.6097 M386.4931,111.3377
		c3.123,4.8987,8.9314,14.0285,13.1929,23.9606c3.6557,8.545,12.8253,41.9258,20.19,68.7494
		c5.2747,19.2071,9.8391,35.7842,11.1447,38.8331c3.1335,7.3219,16.67,84.353,17.7239,95.9897
		c1.055,11.5416,5.2016,41.7274,8.3664,54.3657c2.1517,8.5962,4.461,36.6606,5.6726,53.175
		c-1.8811-0.3865-3.9283-0.7217-6.2669-1.0341c-5.0251-0.6685-9.673-0.7834-14.2061-0.3656
		c-0.6058,0.0522-1.2221,0.094-1.8373,0.1462c-0.2935,0.0209-0.5849,0.0512-0.8774,0.0731
		c-7.3636-55.4635-32.1598-159.3902-32.4011-160.3512c0-0.281-13.0342-60.6943-36.3796-119.311v-0.0219
		c-0.1034-0.2611-0.2079-0.5118-0.3133-0.7614l-0.0313,0.0105c3.8865-18.7392,8.5126-37.5922,13.9335-56.8307
		C384.7697,108.6221,385.4277,109.6572,386.4931,111.3377 M369.9285,164.0323c-0.9192-1.3578-2.6112-3.3831-5.3488-4.9613
		c-4.2928-2.4755-76.0378-8.3142-104.5837-4.0829l0.0199-61.814c2.3501,0.4188,4.7942,0.586,7.1558,0.7322l1.1385,0.0731
		c3.4155,0.2193,6.3923,0.2715,9.1173,0.1556c7.4054-0.3133,14.0902-2.0148,19.8568-5.0752
		c2.3083-1.2231,4.3973-2.653,6.2032-4.2302c0.8889-0.7729,1.7025-1.5876,2.4337-2.4232
		c20.4731,2.8828,37.2047,8.9513,52.6319,19.1037c11.1656,7.3428,19.1455,19.7398,20.6287,22.1536l0.304-0.188
		C375.9135,137.1262,372.7371,150.6116,369.9285,164.0323 M359.9421,89.8536c12.2425,6.1207,23.6159,15.8961,24.0348,17.0983
		c-1.525,5.3896-2.9778,10.7583-4.3774,16.0956c-1.8174-2.9141-9.7138-14.8955-20.6809-22.1119
		c-15.3958-10.1315-32.0961-16.2209-52.4856-19.135c0.188-0.2308,0.3771-0.4606,0.5442-0.6894
		c0.6058-0.7938,1.0226-1.432,1.3568-2.0994l0.0533-0.094c0.8564-1.714-0.188-4.6062-0.7416-5.9014
		C313.055,74.4673,348.4736,84.1183,359.9421,89.8536 M310.7571,52.1778c0.3144,2.4138-0.3645,4.7942-1.0226,7.1026
		c-0.2611,0.9087-0.5337,1.8592-0.7322,2.7888c-0.2507,1.1082-0.4805,2.2039-0.6988,3.3006
		c-0.4596,2.2049-0.9411,4.4809-1.5155,6.7056l-0.3969-0.094l0.3353,0.6695c0.0199,0.0407,2.0054,4.0526,1.0445,5.9745
		l-0.0533,0.1034c-0.3018,0.6058-0.6998,1.2116-1.2847,1.9751c-0.2392,0.3332-0.5003,0.658-0.7729,0.9714h-0.0522l-0.0094,0.0731
		c-0.7531,0.8878-1.6085,1.7443-2.56,2.5695c-1.7652,1.5448-3.8113,2.9444-6.0789,4.1466
		c-5.6716,3.0071-12.2508,4.6898-19.5623,4.9927c-2.6948,0.1138-5.6507,0.0616-9.0453-0.1577l-1.1385-0.0731
		c-2.3825-0.1452-4.8475-0.3134-7.1976-0.7416l0.0104-29.0149c0-0.0637,0.1567-1.5563,1.5876-1.8801
		c1.3474-0.304,8.5021,0.6048,11.1666,0.9818c0.1358,0,13.2118,0.9922,22.4973,0.3865c8.3152-0.5546,13.4541-10.634,14.7378-13.453
		C310.3717,50.3082,310.6328,51.197,310.7571,52.1778 M150.5856,89.8536c11.457-5.7353,46.8757-15.3864,52.2976-16.8372
		c-0.5536,1.2952-1.5981,4.1874-0.7426,5.9014c0.3562,0.7102,0.8147,1.4195,1.4424,2.2561
		c0.1671,0.2079,0.3447,0.4073,0.5118,0.6162c-20.3895,2.9246-37.0909,9.014-52.4971,19.1455
		c-10.9149,7.1861-18.6849,18.9147-20.6705,22.1119c-1.3996-5.3373-2.8504-10.6956-4.3754-16.0851
		C127.0637,105.6662,138.386,95.9534,150.5856,89.8536 M53.4157,393.2362c3.1554-12.6383,7.3114-42.8241,8.3559-54.3657
		c1.0664-11.6367,14.603-88.6678,17.7365-95.9897c1.3056-3.0489,5.8596-19.626,11.1332-38.8331
		c7.3741-26.8235,16.5343-60.2044,20.2015-68.7494c4.2605-9.9321,10.0678-19.0619,13.1815-23.9606
		c1.0748-1.6806,1.7224-2.7157,2.0994-3.3727c5.5254,19.6354,10.2256,38.855,14.1737,57.9786
		c-23.2399,58.482-36.224,118.6551-36.2125,118.8525c-0.2611,1.0445-25.3717,104.9932-32.704,160.4128
		c-3.0071-0.3228-5.7959-0.4899-8.4071-0.5003c-2.0796,0-4.3137,0.1358-6.9991,0.4272c-2.9037,0.3248-5.6705,0.7531-8.241,1.2753
		C48.9567,429.8967,51.2651,401.8323,53.4157,393.2362 M97.5036,466.6628c-6.4341,1.5354-21.5896,2.6018-50.8353-7.5308
		c5.9755-1.2116,26.9061-4.2709,50.9293,5.5264c0.47,0.187,0.6058,0.6988,0.5755,1.0863
		C98.1418,466.1207,97.9527,466.5594,97.5036,466.6628 M98.4342,464.4704c-0.1577-0.1891-0.3447-0.3562-0.5755-0.4502
		c-23.7621-9.6814-44.5151-6.8832-50.9711-5.6288c0.095-1.3275,0.3771-5.5462,0.7948-11.2805
		c2.6112-0.5327,5.4199-0.9714,8.3664-1.2962c2.6634-0.2924,4.836-0.4283,6.925-0.4283c4.2396,0.0219,8.9199,0.4387,14.32,1.3056
		c5.1389,0.8158,9.7231,1.9532,14.0066,3.4688c3.405,1.2011,6.3609,2.559,9.0338,4.1456
		C99.4568,458.9868,98.7789,462.6007,98.4342,464.4704 M134.1245,312.1524c-2.0368,11.1959-17.82,69.4899-20.1806,76.0702
		c-2.1088,5.9003-9.6292,45.007-13.4739,65.384c-2.6634-1.5563-5.588-2.9037-8.9408-4.0934
		c-4.3232-1.525-8.9398-2.6635-14.132-3.4991c-1.8696-0.2924-3.6338-0.5337-5.3468-0.7311
		c7.3417-55.3904,32.4304-159.2847,32.6915-160.3397c0.1264-0.586,12.5965-59.1077,35.8051-117.7882
		c3.2066,15.6997,5.9118,31.3347,8.1261,47.0762c1.9856,14.0484,3.0823,29.4014,3.0823,43.2409
		C145.875,273.078,135.6588,303.7328,134.1245,312.1524 M251.6818,452.1976v0.7197c0.0094,0.9087,0.0209,1.8498-0.1159,2.7271
		c-0.0731,0.4805-0.2611,1.1281-0.751,1.525c-0.2611,0.2194-0.6163,0.376-1.15,0.4899c-1.8383,0.3969-3.9576,0.2517-5.8168,0.1055
		h-0.094c-1.4947-0.1149-3.0186-0.2924-4.4913-0.4606c-0.6058-0.0731-1.222-0.1452-1.8279-0.2183l-66.8589-7.3542
		c-3.9889-0.4377-7.8337-1.4623-11.4371-3.0395c-5.1284-2.2561-11.2492-5.8282-11.3421-10.0783
		c-0.1682-7.2592,1.5343-21.1624,1.5563-21.34l2.0054-77.9179c0.0104-0.7103,1.0748-71.5685,1.0748-79.8304
		c0-13.8813-1.0967-29.2875-3.0802-43.3881c-2.278-16.0956-5.0449-32.0763-8.3559-48.1301
		c0.0199-0.0522,0.0407-0.1055,0.0616-0.1577c0.1463-0.2287,2.3919-3.781,6.5605-6.1928c4.156-2.4023,76.7481-8.053,104.1461-4.0004
		L251.6818,452.1976z M251.7654,154.9765c-28.5981-4.2093-100.199,1.6189-104.4908,4.0944
		c-3.5419,2.0472-5.7029,4.8255-6.4769,5.9536c-2.8306-13.6713-6.057-27.3959-9.6929-41.2772l0.1368,0.0721
		c0.8972-1.4832,9.1602-14.6949,20.7331-22.3093c15.4261-10.1524,32.1484-16.2209,52.6214-19.1037
		c1.1792,1.3474,2.5684,2.6217,4.156,3.8228c4.3869,3.2891,9.9655,5.6716,16.1374,6.8832c1.7965,0.3551,3.7079,0.6162,5.6925,0.7938
		c5.6517,0.5118,11.8978,0.4282,19.1037-0.2611c0.6998-0.0637,1.3996-0.1358,2.0994-0.2193L251.7654,154.9765z M251.7852,92.7458
		c-0.7197,0.0835-1.4414,0.1577-2.161,0.2308c-7.1652,0.6779-13.381,0.7614-18.9899,0.2611
		c-1.9532-0.1786-3.8427-0.4502-5.6193-0.7948c-6.0674-1.1897-11.551-3.5304-15.8543-6.7579
		c-2.0159-1.5145-3.709-3.1753-5.0355-4.9195c-0.6058-0.8032-1.0445-1.4821-1.3787-2.1506
		c-0.9505-1.9114,1.0236-5.9233,1.0445-5.964l0.3342-0.6695l-0.3969,0.1055c-0.7207-2.6112-1.4101-5.3373-2.0566-8.1261
		l-0.2716-1.1803c-0.9098-3.8552-1.8498-7.8451-1.2335-11.7505c0.0627-0.3666,0.1577-0.6893,0.2517-1.0246
		c1.3986,2.8838,6.621,12.4085,14.8318,12.9527c9.2751,0.6058,21.6627-0.3771,21.787-0.3865
		c3.7811-0.3551,11.3014-0.9192,12.701-0.5964c1.4309,0.3353,1.9532,1.3056,2.0587,1.5365L251.7852,92.7458z M259.2324,454.8287
		c-3.4886-0.3447-5.9745-0.0512-6.925,0.1055c0.0522-0.6789,0.0637-1.3589,0.0637-2.0263l0.1034-389.4694l-0.0209-0.1159
		c-0.0209-0.0616-0.5849-1.5448-2.5579-2.0054c-1.8488-0.4387-12.4608,0.5338-12.9109,0.5745
		c-0.1253,0.0115-12.4597,0.9922-21.693,0.3865c-8.4813-0.564-13.8719-11.6868-14.5508-13.17
		c1.15-2.6749,3.5314-4.0735,5.5368-4.7733c3.1638-1.1072,6.6116-1.7767,9.953-2.4128c0.7938-0.1473,1.5772-0.3039,2.3605-0.4595
		c1.3892-0.2716,2.7679-0.5442,4.1571-0.7938c7.4378-1.3693,14.3419-2.2979,21.0997-2.8306
		c8.0624-0.6476,15.635-0.6894,22.4983-0.1254c4.9707,0.4063,9.9738,1.2639,14.8098,2.0994c2.4546,0.4178,4.9937,0.845,7.511,1.221
		c0.9703,0.1462,2.0367,0.2716,3.1648,0.4073c6.3609,0.7729,14.6855,1.808,17.7866,7.2916
		c-0.7092,1.6085-5.9421,12.982-14.3816,13.546c-9.2333,0.6058-22.279-0.375-22.3834-0.3865
		c-0.3979-0.0522-9.6406-1.3579-11.3954-0.9609c-1.5364,0.3447-2.0587,1.7756-2.1109,2.5078L259.2324,454.8287z M359.1703,337.3654
		l1.9103,74.4617c0.0533,2.1736,0.1985,4.3461,0.4283,6.4351c0.5013,4.6166,1.3369,13.1397,1.222,18.3517
		c-0.1776,8.0113-12.5851,10.7165-19.25,12.1673l-0.8669,0.188c-7.8023,1.7234-15.9285,2.4452-23.782,3.145
		c-2.9883,0.2611-6.08,0.5327-9.109,0.8554l-18.7058,2.0169c-5.2339,0.564-10.4668,1.1281-15.6997,1.7025l-0.7625,0.0836
		c-2.3501,0.2611-4.7723,0.5316-7.1642,0.6894c-1.0654,0.0721-2.1934,0.1462-3.3852,0.1243h-0.2287
		c-0.6277,0-1.2743,0-1.8185-0.1974c-1.8488-0.6904-2.0472-2.1527-2.0472-2.183l0.0846-299.5294
		c27.3437-4.0829,100.0726,1.5782,104.2391,3.9805c3.0301,1.7443,4.7419,4.1038,5.495,5.3374
		c-3.3946,16.3975-6.2366,32.7124-8.5544,49.1432c-1.996,14.1006-3.0917,29.5068-3.0917,43.3881
		C358.084,265.7875,359.1588,336.6457,359.1703,337.3654 M396.5829,388.2226c-2.3606-6.5803-18.1418-64.8743-20.1785-76.0702
		c-1.5354-8.4196-11.762-39.0744-17.6414-54.6801c0.0105-13.8395,1.0957-29.1925,3.0802-43.2409
		c2.277-16.1478,5.0658-32.1922,8.3883-48.2972c23.5104,59.0753,36.1696,118.4138,36.296,119.0196
		c0.2496,1.0445,25.026,104.8971,32.3886,160.3386c-0.376,0.0324-0.751,0.0522-1.1281,0.094
		c-2.9663,0.3353-5.9222,0.7938-8.7726,1.3798c-3.7926,0.7834-7.2174,1.7338-10.4554,2.9037
		c-3.1763,1.1489-5.9651,2.4441-8.5032,3.9367C406.2036,433.2297,398.6938,394.123,396.5829,388.2226 M410.1832,454.3065
		c2.5694-1.5145,5.3781-2.8306,8.6055-4.0004c3.2066-1.1583,6.6012-2.0984,10.3624-2.8723
		c2.8306-0.5839,5.7645-1.0445,8.7111-1.3672c0.8868-0.094,1.7756-0.1671,2.6624-0.2308c0.6162-0.0522,1.2325-0.094,1.8488-0.1556
		c4.4819-0.4073,9.0766-0.2935,14.0599,0.376c2.3908,0.3134,4.4798,0.658,6.4027,1.0549c0.4272,5.7343,0.7092,9.9529,0.7928,11.2805
		c-6.4434-1.2544-27.1985-4.0526-50.9606,5.6288c-0.2287,0.094-0.4178,0.2611-0.5734,0.4502
		C411.7384,462.6007,411.0699,458.9868,410.1832,454.3065 M463.9117,459.1529c-29.2886,10.1117-44.4546,9.0453-50.8886,7.5099
		c-0.4585-0.1034-0.6476-0.5421-0.6789-0.9181c-0.0209-0.3875,0.1044-0.8993,0.5755-1.0863
		c13.4844-5.494,25.9869-6.9459,35.4187-6.9459c7.4472,0,12.983,0.8972,15.5734,1.4299V459.1529z"
        />
      </g>
    </svg>
  );
}
